<template>
  <div class="module-selected-filter-wrapper" v-if="filters.selectedFiltersFilled">
    <div class="selected-filter" v-for="(group, index) in filters.selectedFilters" :key="index">
      <div class="selected__item" v-for="(element, idx) in group" :key="idx">
        <div class="item__item" @click="() => {group.splice(group.indexOf(element), 1); handleFilter()}">
          <span v-if="index === 'express'">{{ $t('list.selectedfilter.express') }}</span>
          <span v-if="index === 'numberOfContacts'"> {{ $t('list.selectedfilter.numberOfContacts') }}</span>
          <span v-if="index === 'size'"> {{ $t('list.selectedfilter.size') }}</span>
          <span v-if="index === 'keying'"> {{ $t('list.selectedfilter.keying') }}</span>
          <span v-if="index !== 'express'" class="icon-times-after">{{element.value}}</span></div>
      </div>
    </div>
    <div class="selected-filter" v-for="(group, key,index) in filters.rangeFilters" :key="index">
      <div class="selected__item">
        <div class="item__item" @click="removeRangeFilters(key)" v-if="group.options[0].min === group.options[1].max && group.options[0].min !== null">
          <span>{{ $t('list.filter.cableDiameter') }} </span>
          <span class="icon-times-after">{{group.options[0].min}}</span>
        </div>
      </div>
    </div>
    <div class="selected-filter--delete-all link" @click="clearFilters">
      <span>{{ $t('list.selectedfilter.deleteall') }}</span>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue'
import { useGlobalStore } from '@/stores'
import { useFilterStore } from "@/stores/filter";
import { useMatingPairsFilterStore } from "@/stores/matingPairsFilter";
import { useMatingPairsStore } from "@/stores/matingPairs";
import { usePartsStore } from '@/stores/parts'

const globals = useGlobalStore()
const matingPairs = useMatingPairsStore()
const parts = usePartsStore()

const props = defineProps({
  filterType: {
    type: String,
    default: 'List'
  }
})

const filters = computed(() =>
{
  if (props.filterType === 'List')
  {
    return useFilterStore()
  } else {
    return useMatingPairsFilterStore()
  }
})

function clearFilters () {
  filters.value.clearSelectedFilters()
  handleFilter()
}

function handleFilter()
{
  if (props.filterType === 'List')
  {
    globals.filter()
    parts.currentPage = 1
  } else {
    matingPairs.filterMatingPairs()
    matingPairs.currentPage = 1
  }
}

function removeRangeFilters(key) {
  filters.value.rangeFilters[key].options[0].min = filters.value.filters[key].options[0].min
  filters.value.rangeFilters[key].options[1].max = filters.value.filters[key].options[1].max
  handleFilter()
}
</script>

